module.exports = __webpack_public_path__ + "img/reflect-sea.9dc792c.jpg";